export default __webpack_public_path__ + "static/media/iam_background_m1.05a6be48.jpg";